var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"navbar",attrs:{"fixed":"","app":"","color":"gray"}},[_c('v-toolbar-title',[_c('h1',[_c('router-link',{attrs:{"to":"/create_partie"}},[_c('v-icon',[_vm._v("fa-gamepad")]),_vm._v("\n          Flashcards\n        ")],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69b08a3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navbar.vue
// module id = null
// module chunks = 